export default "__VITE_ASSET__C0kLAb_N__"